module.exports = __webpack_public_path__ + "img/email.c49e9918.svg";